import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner"
}
const _hoisted_2 = {
  key: 1,
  class: "admin-page-wr"
}
const _hoisted_3 = { class: "dashboard-header" }
const _hoisted_4 = { class: "subtitle-main" }
const _hoisted_5 = { class: "filters" }
const _hoisted_6 = { class: "table-default" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "title-main" }, "Builders", -1)),
          _createElementVNode("h3", _hoisted_4, _toDisplayString($setup.plural($setup.builders.length, "Builder")), 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode($setup["InputSearch"], {
              modelValue: $setup.searchQuery,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchQuery) = $event)),
              placeholder: "Search",
              theme: "filter"
            }, null, 8, ["modelValue"]),
            _createElementVNode("button", {
              class: "button default primary add-btn-primary",
              onClick: $setup.toCreateBuilder
            }, "Add Builder")
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "table-wrapper" }, null, -1)),
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.tableHeaders, (header) => {
                  return _createElementVNode("th", { key: header }, _toDisplayString(header), 1)
                }), 64))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.builders, (builder) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: builder.email,
                  onClick: ($event: any) => ($setup.onClickBuilder(builder._id))
                }, [
                  _createElementVNode("td", _hoisted_8, _toDisplayString(builder.name), 1),
                  _createElementVNode("td", null, _toDisplayString(builder.email || "-"), 1),
                  _createElementVNode("td", null, _toDisplayString(builder.phone || "-"), 1),
                  _createElementVNode("td", null, _toDisplayString(builder.state || "-"), 1)
                ], 8, _hoisted_7))
              }), 128))
            ])
          ])
        ])
      ]))
}